import React, { useEffect, useRef } from "react";
import "../../Style/Theme/index.css";
import lottie from "lottie-web";
const ErrorAnimation = () => {
  const container = useRef(null);

  useEffect(() => {
    lottie.loadAnimation({
      container: container.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: require("../../utils/lottie/error.json"),
    });
  }, []);
  return (
    <div>
      <div
        className="lottieContainer animationFilter"
        ref={container}
        style={{
          width: "200px",
          height: "200px",
          position: "relative",
        }}
      >
        <img src="/assets/stars.svg" alt="stars" className={`stars lottieBg`} />
        <img
          src="/assets/pinkCircle.svg"
          alt="circle"
          className={`circle lottieBg`}
        />
      </div>
    </div>
  );
};

export default ErrorAnimation;
